<div class="membership-card">
    <div class="left">
        <div class="emblem" [ngClass]="{'net-jets': membership?.provider === 'NetJets'}">
            {{membership?.provider || 'Membership'}}
        </div>
        <div class="details">
            <div class="type-row">
                <div class="type">{{membership?.type || 'Membership type not specified'}}</div>
            </div>
            <div class="type">
                Default Aircraft: {{membership?.defaultAircraft?.category || 'Not specified'}} -
                {{membership?.defaultAircraft?.name || 'Not specified'}}
                <ng-container *ngIf="membership?.seatingConfiguration !== null && membership?.seatingConfiguration !== undefined">
                    ({{membership?.seatingConfiguration}} Seats)
                </ng-container>
            </div>
        </div>
    </div>
    <div class="right" *ngIf="canShowEdit">
        <div class="action-icon" (click)="onClickEdit()">
            <app-svg-loader height="20px" url="assets/svg/edit-cube.svg"></app-svg-loader>
        </div>
    </div>
</div>
